import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

export const translations = {
  it: {
    nav: {
      home: 'Home',
      rooms: 'Camere',
      admin: 'Admin'
    },
    home: {
      title: 'Curtigghiu',
      tagline: 'Bed & Breakfast',
      subtitle: 'Un\'oasi di tranquillità nel cuore della città',
      bookNow: 'Prenota Ora',
      ourRooms: 'Le Nostre Camere',
      viewRooms: 'Vedi Tutte le Camere',
      ourBnb: 'Il Nostro B&B',
      ourBnbDesc: 'Il B&B Curtigghiu si trova nel cuore del centro storico di Belpasso, all\'interno di un caratteristico fabbricato a corte, tipica espressione dell\'architettura siciliana tradizionale. Completamente ristrutturato con cura, il B&B conserva intatti gli elementi architettonici originali, armonizzandoli con comfort moderni e un\'atmosfera calda e accogliente.',
      terrace: 'La Posizione',
      terraceTitle: 'Nel cuore di Belpasso',
      terraceDesc: 'La posizione centrale permette di vivere Belpasso a piedi e di raggiungere facilmente le principali attrazioni della città, tra cui il Duomo di Belpasso, il Teatro Comunale Nino Martoglio e le suggestive vie del centro storico. La struttura rappresenta inoltre un ottimo punto di partenza per scoprire le bellezze del territorio etneo. A pochi chilometri si trova infatti l\'Etna, patrimonio UNESCO e protagonista indiscusso del paesaggio siciliano, con i suoi percorsi naturalistici, i panorami mozzafiato e le numerose attività da vivere in ogni stagione. La vicinanza a Catania consente inoltre di raggiungere comodamente il centro storico della città, il lungomare e le principali località della costa orientale. Soggiornare al B&B Curtigghiu significa immergersi nell\'autenticità della Sicilia, tra storia, cultura, natura e sapori locali, scoprendo un territorio ricco di esperienze e tradizioni. Un luogo dove il fascino della tradizione siciliana incontra il comfort di un soggiorno contemporaneo.',
      courtyard: 'Il Cortile',
      courtyardTitle: 'Vivere all\'Aperto',
      courtyardDesc: 'Il nome Curtigghiu richiama proprio l\'antico cortile siciliano, luogo di incontro e di vita quotidiana, e racchiude lo spirito di una struttura pensata per far sentire ogni ospite a casa. Gli ambienti, curati nei dettagli, offrono un soggiorno piacevole e rilassante, dove tradizione, semplicità e ospitalità siciliana si incontrano.',
      breakfast: 'La Colazione',
      breakfastTitle: 'Sapori di Sicilia',
      breakfastDesc: 'La nostra sala colazione, intima e accogliente, è il luogo ideale per iniziare la giornata con calma. Un ambiente curato e piacevole dove gli ospiti possono concedersi una pausa e prepararsi in autonomia un buon caffè, un tè o una tisana, sentendosi come a casa.',
      atmosphere: 'Atmosfera',
      atmosphereTitle: 'Vivi l\'Esperienza Siciliana'
    },
    rooms: {
      title: 'Le Nostre Camere',
      subtitle: 'Scegli la camera perfetta per il tuo soggiorno',
      perNight: 'a notte',
      guests: 'ospiti',
      bookRoom: 'Prenota Camera',
      available: 'Disponibile',
      unavailable: 'Non Disponibile',
      amenities: 'Servizi'
    },
    booking: {
      title: 'Completa la Prenotazione',
      guestDetails: 'Dettagli Ospite',
      name: 'Nome Completo',
      email: 'Email',
      phone: 'Telefono',
      checkIn: 'Check-in',
      checkOut: 'Check-out',
      guests: 'Numero Ospiti',
      nights: 'notti',
      total: 'Totale',
      continueToPayment: 'Continua al Pagamento',
      selectPayment: 'Seleziona Metodo di Pagamento',
      creditCard: 'Carta di Credito',
      paypal: 'PayPal',
      processing: 'Elaborazione...',
      bookingSummary: 'Riepilogo Prenotazione'
    },
    payment: {
      success: 'Pagamento Completato!',
      successMessage: 'La tua prenotazione è stata confermata. Riceverai un\'email di conferma a breve.',
      cancelled: 'Pagamento Annullato',
      cancelledMessage: 'Il pagamento è stato annullato. Puoi riprovare quando vuoi.',
      backToRooms: 'Torna alle Camere',
      bookingCode: 'Codice Prenotazione',
      checkingPayment: 'Verifica pagamento in corso...'
    },
    admin: {
      login: 'Accedi Admin',
      username: 'Username',
      password: 'Password',
      loginButton: 'Accedi',
      dashboard: 'Dashboard Admin',
      bookings: 'Prenotazioni',
      rooms: 'Gestione Camere',
      logout: 'Esci',
      addRoom: 'Aggiungi Camera',
      editRoom: 'Modifica Camera',
      deleteRoom: 'Elimina Camera',
      roomName: 'Nome Camera',
      description: 'Descrizione',
      price: 'Prezzo per Notte',
      maxGuests: 'Ospiti Massimi',
      imageUrl: 'URL Immagine',
      save: 'Salva',
      cancel: 'Annulla',
      bookingDetails: 'Dettagli Prenotazione',
      status: 'Stato',
      confirmed: 'Confermata',
      pending: 'In Attesa',
      cancelled: 'Annullata',
      paid: 'Pagato',
      updateStatus: 'Aggiorna Stato'
    },
    common: {
      loading: 'Caricamento...',
      error: 'Errore',
      success: 'Successo'
    }
  },
  en: {
    nav: {
      home: 'Home',
      rooms: 'Rooms',
      admin: 'Admin'
    },
    home: {
      title: 'Curtigghiu',
      tagline: 'Bed & Breakfast',
      subtitle: 'An oasis of tranquility in the heart of the city',
      bookNow: 'Book Now',
      ourRooms: 'Our Rooms',
      viewRooms: 'View All Rooms',
      ourBnb: 'Our B&B',
      ourBnbDesc: 'B&B Curtigghiu is located in the heart of Belpasso\'s historic center, inside a characteristic courtyard building, a typical expression of traditional Sicilian architecture. Fully renovated with care, the B&B preserves its original architectural elements, harmonizing them with modern comforts and a warm, welcoming atmosphere.',
      terrace: 'Location',
      terraceTitle: 'In the heart of Belpasso',
      terraceDesc: 'The central location allows you to experience Belpasso on foot and easily reach the city\'s main attractions, including the Belpasso Cathedral, the Nino Martoglio Municipal Theatre and the picturesque streets of the historic center. The property is also an excellent starting point to discover the beauties of the Etna territory. Just a few kilometers away is Mount Etna, a UNESCO World Heritage Site and undisputed protagonist of the Sicilian landscape, with its nature trails, breathtaking views and many activities to experience in every season. The proximity to Catania also allows you to easily reach the city\'s historic center, the seafront and the main resorts of the eastern coast. Staying at B&B Curtigghiu means immersing yourself in the authenticity of Sicily, between history, culture, nature and local flavors, discovering a territory rich in experiences and traditions. A place where the charm of Sicilian tradition meets the comfort of a contemporary stay.',
      courtyard: 'The Courtyard',
      courtyardTitle: 'Outdoor Living',
      courtyardDesc: 'The name Curtigghiu recalls the ancient Sicilian courtyard, a place of meeting and daily life, and embodies the spirit of a property designed to make every guest feel at home. The spaces, curated in every detail, offer a pleasant and relaxing stay, where tradition, simplicity and Sicilian hospitality meet.',
      breakfast: 'Breakfast',
      breakfastTitle: 'Flavours of Sicily',
      breakfastDesc: 'Our breakfast room, intimate and welcoming, is the ideal place to start the day peacefully. A curated and pleasant environment where guests can take a break and prepare themselves a good coffee, tea or herbal infusion, feeling right at home.',
      atmosphere: 'Atmosphere',
      atmosphereTitle: 'Live the Sicilian Experience'
    },
    rooms: {
      title: 'Our Rooms',
      subtitle: 'Choose the perfect room for your stay',
      perNight: 'per night',
      guests: 'guests',
      bookRoom: 'Book Room',
      available: 'Available',
      unavailable: 'Unavailable',
      amenities: 'Amenities'
    },
    booking: {
      title: 'Complete Your Booking',
      guestDetails: 'Guest Details',
      name: 'Full Name',
      email: 'Email',
      phone: 'Phone',
      checkIn: 'Check-in',
      checkOut: 'Check-out',
      guests: 'Number of Guests',
      nights: 'nights',
      total: 'Total',
      continueToPayment: 'Continue to Payment',
      selectPayment: 'Select Payment Method',
      creditCard: 'Credit Card',
      paypal: 'PayPal',
      processing: 'Processing...',
      bookingSummary: 'Booking Summary'
    },
    payment: {
      success: 'Payment Successful!',
      successMessage: 'Your booking has been confirmed. You will receive a confirmation email shortly.',
      cancelled: 'Payment Cancelled',
      cancelledMessage: 'The payment was cancelled. You can try again anytime.',
      backToRooms: 'Back to Rooms',
      bookingCode: 'Booking Code',
      checkingPayment: 'Checking payment status...'
    },
    admin: {
      login: 'Admin Login',
      username: 'Username',
      password: 'Password',
      loginButton: 'Login',
      dashboard: 'Admin Dashboard',
      bookings: 'Bookings',
      rooms: 'Room Management',
      logout: 'Logout',
      addRoom: 'Add Room',
      editRoom: 'Edit Room',
      deleteRoom: 'Delete Room',
      roomName: 'Room Name',
      description: 'Description',
      price: 'Price per Night',
      maxGuests: 'Max Guests',
      imageUrl: 'Image URL',
      save: 'Save',
      cancel: 'Cancel',
      bookingDetails: 'Booking Details',
      status: 'Status',
      confirmed: 'Confirmed',
      pending: 'Pending',
      cancelled: 'Cancelled',
      paid: 'Paid',
      updateStatus: 'Update Status'
    },
    common: {
      loading: 'Loading...',
      error: 'Error',
      success: 'Success'
    }
  }
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('it');

  const t = (key) => {
    const keys = key.split('.');
    let value = translations[language];
    for (const k of keys) {
      value = value?.[k];
    }
    return value || key;
  };

  const switchLanguage = (lang) => {
    setLanguage(lang);
    localStorage.setItem('language', lang);
  };

  useEffect(() => {
    const savedLang = localStorage.getItem('language');
    if (savedLang && (savedLang === 'it' || savedLang === 'en')) {
      setLanguage(savedLang);
    }
  }, []);

  return (
    <LanguageContext.Provider value={{ language, setLanguage: switchLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return context;
};
